import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS, STALE_TIME } from '@/libs/constants'
import { orgApi } from '@/services/api'

// skipErrorRedirect: org profile only supplies optional PDF header details
// (address, org number, etc.) — a fetch failure shouldn't block the
// Economy/Invoicing pages behind the app-wide "something went wrong" redirect.
export function useOrgProfile(orgID: string, enabled = true) {
  return useQuery({
    queryKey: QUERY_KEYS.org.profile(orgID),
    queryFn: () => orgApi.getProfile(orgID),
    enabled: enabled && !!orgID,
    staleTime: STALE_TIME['24Hours'],
    meta: { skipErrorRedirect: true },
  })
}
